/**
 * Completed years and months since a join date, as of today.
 *
 * <p>Calendar arithmetic rather than days ÷ 365: someone who joined on 31 January has a whole
 * month of service on the last day of February, and a division would say otherwise.
 */
export function serviceLength(
  joinDate: string | null | undefined,
  today: Date = new Date(),
): { years: number; months: number; label: string } | null {
  if (!joinDate) return null
  const [y, m, d] = joinDate.split('-').map(Number)
  if (!y || !m || !d) return null

  let months = (today.getFullYear() - y) * 12 + (today.getMonth() + 1 - m)
  if (today.getDate() < d) months -= 1
  if (months < 0) return { years: 0, months: 0, label: 'Not started yet' }

  const years = Math.floor(months / 12)
  const rest = months % 12
  const parts = [
    years > 0 ? `${years} yr${years === 1 ? '' : 's'}` : null,
    rest > 0 || years === 0 ? `${rest} mo${rest === 1 ? '' : 's'}` : null,
  ].filter(Boolean)
  return { years, months: rest, label: parts.join(' ') }
}
